<template>
  <div>
    <b-container fluid>
      <b-row style="margin-bottom: 5px;">
        <b-col cols="auto">
          查詢起訖時間:
        </b-col>
        <b-col cols="10">
          <b-input-group style="width: 20vh;display: inline-flex;">
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.minvalue"
              style="width: 13vh;"
              min="1960-01-01"
              :max="twtimeparse(timepicker.maxvalue)"
            ></datepicker>
          </b-input-group>
          <span style="display: inline-flex; margin-right: 1rem">~</span>
          <b-input-group
            style="width: 20vh;display: inline-flex; margin-right: 1rem;"
          >
            <b-input-group-prepend is-text>
              <b-icon icon="calendar3"></b-icon>
            </b-input-group-prepend>
            <datepicker
              v-model="timepicker.maxvalue"
              style="width: 13vh;"
              :min="twtimeparse(timepicker.minvalue)"
              :max="timepicker.max"
            ></datepicker>
          </b-input-group>
          <template v-if="ifloading">
            <b-spinner
              style="width: 1.5rem; height: 1.5rem;"
              variant="success"
              label="Spinning"
            />
          </template>
        </b-col>
      </b-row>
      <b-row
        v-show="fruit.fruitlist.items.length > 0"
        style="margin-bottom: 5px;"
      >
        <b-col cols="auto">
          市場作物名稱:
        </b-col>
        <b-col cols="10">
          <v-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-show="fruit.fruitlist.items.length > 0"
            v-model="fruit.fruitlist.value"
            :options="fruit.fruitlist.options"
            :selectable="(car) => car.disabled"
          ></v-select>
          <!-- <b-spinner v-show="fruit.fruitlist.items.length==0" style="width: 1.5rem; height: 1.5rem;" variant="success" label="Spinning" /> -->
        </b-col>
      </b-row>
      <div v-show="fruit.marketlist.options.length > 0">
        <b-row style="margin-bottom: 5px;">
          <b-col cols="auto">
            交易市場名稱:
          </b-col>
          <b-col cols="8">
            <b-form-radio-group
              id="checkbox-group-1"
              v-show="fruit.marketlist.options.length > 0"
              v-model="fruit.marketlist.value"
              :options="fruit.marketlist.options"
            >
            </b-form-radio-group>
          </b-col>
        </b-row>
        <!-- <b-row style="margin-bottom: 15px;">
                          <b-col cols="auto">
                              <b-button block style="background-color: #4f8321;font-size: 0.8rem;" @click="optionscheck">查詢</b-button>
                          </b-col>
                      </b-row> -->
        <b-row style="margin-bottom: 5px;">
          <b-col>
            <b-form-checkbox
              id="checkbox-1"
              v-show="fruit.obj.chart.options.yaxis.length > 0"
              v-model="dataLabels"
              :value="true"
              :unchecked-value="false"
              >顯示數值標籤
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>
        
    </b-container>
    <!-- <template v-if="ifloading">
      <b-spinner
        style="width: 1.5rem; height: 1.5rem;"
        variant="success"
        label="Spinning"
      />
    </template>
    <template v-else> -->
    <div style="width: 100%;">
      <apexchart
        ref="chart1ref"
        height="450"
        type="line"
        :options="fruit.obj.chart.options"
        :series="fruit.obj.chart.series"
      ></apexchart>
    </div>
    <!-- </template> -->
    <div>※值為0代表無資料</div>
  </div>
</template>

<script>
import CROPCODELIST from "@/data/CROP_CODE_LIST.json";
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    // maxDate.setDate(date.getDate() + 1);
    const minDate = new Date(today);
    console.log(["getItem('Crop')",sessionStorage.getItem("Crop")])
    if(sessionStorage.getItem("Crop") != null) minDate.setDate(date.getDate() - 10);
    else minDate.setDate(date.getDate() - 30);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      dataLabels:true,
      fruit: {
        fruitlist: {
          value: { label: "請選擇", code: "請選擇", disabled: false },
          options: [],
          items: [],
          BA_items:[],
        },
        marketlist: {
          value: [],
          options: [],
          allitems: [],
          items: [],
        },
        mainlist: [],
        ifcrop: false,
        iffirst: true,
        ifchartshow: false,
        averageprice: false,
        maintainprice: false,
        overylayshow: true,
        selectlist: [0, "梨子", null],
        typeoptionslist: [
          { text: "請選擇種類", value: null, disabled: true },
          { text: "水果", value: 0 },
          { text: "蔬菜", value: 1 },
          { text: "雜糧特作", value: 2 },
        ],
        options: [
          { text: "請選擇作物", value: null },
          { text: "梨子", value: "梨子" },
          { text: "木瓜", value: "木瓜" },
          { text: "鳳梨", value: "鳳梨" },
        ],
        obj: {
          chart: {
            series: [],
            options: {
              chart: {
                height: 450,
                type: "line",
                zoom: {
                  enabled: false,
                },
              },
              title: {
                text: "",
              },
              dataLabels: {
                enabled: true,
              },
              stroke: { //設定線條格式[只限line & Area模式]
                curve: 'smooth', //路徑平滑
              },
              noData: {
                text: "請選擇市場作物",
                align: "center",
                verticalAlign: "middle",
              },
              labels: [],
              yaxis: [],
              colors: [
                "#008FFB",
                "#19535f",
                "#FEB019",
                "#FF4560",
                "#775DD0",
                "#1c22ce",
                "#ff7b3d",
                "#f9b5c0",
                "#4c1a11",
              ],
              // xaxis: {
              //   type: "datetime",
              //   labels: {
              //     formatter: function(value, timestamp) {
              //       var date = new Date(timestamp);
              //       if (date.getFullYear() < 1975) return;
              //       var year = date.getFullYear() - 1911;
              //       return (
              //         year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
              //       ); // The formatter function overrides format property
              //     },
              //   },
              // },
              plotOptions: {
                bar: {
                  columnWidth: "20%",
                },
              },
              grid: {
                padding: {
                  right: 10,
                  left: 10,
                },
              },
            },
          },
        },
        countryoptions: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: "top",
              },
            },
          },
          title: {
            text: "108年各縣市 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "台中市",
              "台北市",
              "台東縣",
              "台南市",
              "宜蘭縣",
              "花蓮縣",
              "南投縣",
              "屏東縣",
              "苗栗縣",
              "桃園市",
              "高雄市",
              "雲林縣",
              "新北市",
              "新竹縣",
              "嘉義縣",
              "彰化縣",
            ],
          },
          yaxis: [
            {
              title: {
                text: "各縣市",
              },
            },
          ],
          // colors: ['#0000ff', '#8a2be2', '#a52a2a', '#deb887', '#5f9ea0', '#7fff00', '#d2691e', '#ff7f50', '#6495ed', '#dc143c', '#00ffff', '#00008b', '#008b8b', '#b8860b', '#006400', '#8b008b']
        },
        charyioptions: {
          chart: {
            // height: 350,
            type: "bar",
          },
          title: {
            text: "108年嘉義 鄉鎮 種植面積",
          },
          tooltip: {
            shared: true,
            intersect: false,
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [
              "大林鎮",
              "中埔鄉",
              "六腳鄉",
              "太保市",
              "水上鄉",
              "布袋鎮",
              "民雄鄉",
              "朴子市",
              "竹崎鄉",
              "東石鄉",
              "大埔鄉",
              "鹿草鄉",
              "番路鄉",
              "新港鄉",
              "溪口鄉",
              "義竹鄉",
            ],
          },
          yaxis: [
            {
              title: {
                text: "種植面積(公頃)",
              },
            },
          ],
        },
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "產銷儀錶板",
          active: true,
        },
        {
          text: "農產品交易價量分析",
          active: true,
        },
      ],
      ifloading: false,
      cropcodelist: CROPCODELIST,
      // timepicker: {
      //     minvalue: minDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     maxvalue: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     max: maxDate.toLocaleString().split(' ')[0].split('/').join('-'),
      //     min: minDate.toLocaleString().split(' ')[0].split('/').join('-')
      // },
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-07-12",
        // maxvalue: "110-07-15",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
        min: minDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      croplandlist: [],
      apiGetCropForChart: (data) =>
        this.userRequest.post("/API/Default/getCropForChart", data),
      apiGetCropFromDate: (data) =>
        this.userRequest.post("/API/Default/getCropFromDate", data),
      apiGetMarketFromCrop: (data) =>
        this.userRequest.post("/API/Default/getMarketFromCrop", data),
    };
  },
  mounted() {
    // this.checkLogin();
    this.init();
  },
  components: {
    datepicker,
  },
  // mounted(){
  //     // this.FunctionToken(this.getCropLandList, {});

  // },
  watch: {
    "fruit.fruitlist.value"(value) {
      this.getmarketdetial(value.code);
    },
    "timepicker.maxvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "timepicker.minvalue"() {
      if (!this.iffirst)
        // this.updatechart()
        this.init();
    },
    "fruit.marketlist.value"(value) {
      if (value != "" && value != null) this.optionscheck();
      else this.chartinit();
    },
    // "fruit.averageprice"() {
    //   this.optionscheck();
    // },
    // "fruit.maintainprice"() {
    //   this.optionscheck();
    // },
    "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
    }
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000001", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      }
    },
    getCropFromDate(data) {
      this.apiGetCropFromDate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.CROP,
                code: x.CROP_CODE,
                disabled: true,
              };
              this.fruit.fruitlist.items.push(obj);
            });
            this.fruit.fruitlist.options = this.fruit.fruitlist.items.slice(0);
            this.fruit.fruitlist.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
            let cropname = sessionStorage.getItem("Crop");
            if (this.IsNull(cropname) != "") {
              console.log("cropname",cropname)
              let index = this.fruit.fruitlist.options.findIndex(
                (x) => x.code == cropname
              );
              if (index != -1) {
                let subitem = this.fruit.fruitlist.options[index];
                this.fruit.fruitlist.value = {
                  label: subitem.label,
                  code: subitem.code,
                  disabled: false,
                };
                this.ifcrop = true;
                sessionStorage.removeItem("Crop");
                this.getmarketdetial(subitem.code);
              } else {
                this.fruit.fruitlist.value = {
                  label: "請選擇",
                  code: "請選擇",
                  disabled: false,
                };
              }
            } else {
              this.fruit.fruitlist.value = {
                label: "請選擇",
                code: "請選擇",
                disabled: false,
              };
            }
            this.ifloading = false;
            // this.fruit.fruitlist.items = JSON.parse(json.Data)
            // this.createchart()
          }
        })
        .catch((err) => console.warn(err));
    },
    //抓出作物市場清單
    getMarketFromCrop(data) {
      this.apiGetMarketFromCrop(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let arr = JSON.parse(json.Data);
            this.fruit.marketlist.options = [];
            this.fruit.marketlist.value = [];
            this.fruit.averageprice = false;
            this.fruit.maintainprice = false;
            arr.forEach((x) => {
              let obj = {
                text: x.MARKET,
                value: x.MARKET_CODE,
              };
              this.fruit.marketlist.options.push(obj);
            });
            let obj = {
              text: "全國",
              value: "全國",
            };
            this.fruit.marketlist.options.unshift(obj);
            if (this.ifcrop) {
              this.fruit.marketlist.value.push("全國");
              this.fruit.marketlist.value = "全國";
            }

            this.ifloading = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    getCropForChart(data) {
      this.apiGetCropForChart(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            //console.log(JSON.parse(json.Data));
            //console.log(JSON.parse(json.Data).CROP_PRICEMNG_TRADE_OUT);
            this.fruit.fruitlist.items = JSON.parse(json.Data).CROP_PRICEMNG_TRADE_OUT;
            this.fruit.fruitlist.BA_items = JSON.parse(json.Data).BA_TRADE_M_OUTPUT;
            this.createnewchart();
          }
        })
        .catch((err) => console.warn(err));
    },
    chartinit() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      this.fruit.obj.chart.options.xaxis = {};
      this.dataLabels=true;
    },
    init() {
      this.fruit.fruitlist.items = [];
      this.fruit.fruitlist.options = [];
      this.fruit.marketlist.options = [];
      this.fruit.marketlist.value = [];
      this.fruit.averageprice = false;
      this.fruit.maintainprice = false;
      this.ifloading = true;
      this.chartinit();
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;
      console.log("init",sessionStorage.getItem("Crop"))
      if (this.IsNull(sessionStorage.getItem("Crop")) != "") {
        window.setTimeout(() => {
          this.$parent.$parent.$parent.mainpage.tabnum = 1;
        });
      }

      // let diff = Math.floor((Date.parse(localmaxtime.join('-')) - Date.parse(localmintime.join('-'))) / 86400000);

      // if(diff>31)
      // {
      //     alert("時間選擇區間不能超過1個月")
      // }
      // else
      // {
      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.getCropFromDate, obj);
      // }
    },
    getmarketdetial(value) {
      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let diff = Math.floor(
        (Date.parse(localmaxtime.join("-")) -
          Date.parse(localmintime.join("-"))) /
          86400000
      );

      if (value != "請選擇") {
        if (diff > 31) {
          alert("時間選擇區間不能超過1個月");
        } else {
          this.ifloading = true;
          let obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: value,
          };
          this.FunctionToken(this.getMarketFromCrop, obj);
        }
      }
    },
    getchartdata() {
      if (
        this.fruit.marketlist.value != "" &&
        this.fruit.fruitlist.value.code != "請選擇"
      ) {
        this.ifloading = true;
        // this.fruit.ifchartshow = true
        let localmintime = this.timepicker.minvalue.split("-");
        localmintime[0] = parseInt(localmintime[0]) + 1911;
        let localmaxtime = this.timepicker.maxvalue.split("-");
        localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

        let obj = {};

        if (this.fruit.marketlist.value == "全國") {
          let optionlist = [];

          this.fruit.marketlist.options.forEach((x) => {
            optionlist.push(x.value);
          });

          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: optionlist,
          };
        } else {
          obj = {
            start_date: localmintime.join("-"),
            end_date: localmaxtime.join("-"),
            CROP_CODE: this.fruit.fruitlist.value.code,
            MARKET_CODE: [this.fruit.marketlist.value],
          };
        }
        this.FunctionToken(this.getCropForChart, obj);
      }
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    changetimeformat(time) {
      let tt = time.split("-");
      tt[0] = parseInt(tt[0]) - 1911;
      return tt.join("-");
    },
    optionscheck() {
      this.getchartdata();
    },
    createnewchart() {
      this.fruit.obj.chart.series = [];
      this.fruit.obj.chart.options.labels = [];
      this.fruit.obj.chart.options.yaxis = [];
      
      // let serieslist = [], datelist = []
      let mainlist = [],
        datelist = [],
        serieslist = [];

      for (let j in this.fruit.fruitlist.items) {
        let subitem10 = this.fruit.fruitlist.items[j];
        if (datelist.indexOf(subitem10.ANA_DATE) == -1) {
          datelist.push(subitem10.ANA_DATE);
        }
      }

      let list1 = [];
      if (this.fruit.marketlist.value == "全國") {
        for (let i in datelist) {
          let subtime = datelist[i];
          let allavgprice = 0,
            allvolume = 0,
            count = 0;
            //全國交易平均價格直接抓BA_TRADE_M的WA
            console.log("BA_items",this.fruit.fruitlist.BA_items)
            for (let j in this.fruit.fruitlist.BA_items) {
              let subitem2 = this.fruit.fruitlist.BA_items[j];

              if (
                subitem2.ANA_DATE == subtime
              ) {
                allavgprice = subitem2.WA;
              }
            }
            //計算全國市場交易量
            for (let j in this.fruit.fruitlist.items) {
              let subitem2 = this.fruit.fruitlist.items[j];

              if (
                subitem2.ANA_DATE == subtime &&
                subitem2.CROP_CODE == this.fruit.fruitlist.value.code
              ) {
                allvolume = allvolume + subitem2.VOLUME;
                count++;
              }
            }
          // for (let j in this.fruit.fruitlist.items) {
          //   let subitem2 = this.fruit.fruitlist.items[j];

          //   if (
          //     subitem2.ANA_DATE == subtime &&
          //     subitem2.CROP_CODE == this.fruit.fruitlist.value.code
          //   ) {
          //     allavgprice = allavgprice + subitem2.PRICE_AVG;
          //     allvolume = allvolume + subitem2.VOLUME;
          //     count++;
          //   }
          // }

          let obj1 = {
            date: subtime,
            avgprice: Math.round(allavgprice),
            volume: Math.round(allvolume / count),
          };
          list1.push(obj1);
        }
        let obj2 = { name: "全國", data: list1 };
        mainlist.push(obj2);
      } else {
        let marketindex = this.fruit.marketlist.options.findIndex(
          (x) => x.value == this.fruit.marketlist.value
        );
        let subitem1 = this.fruit.marketlist.options[marketindex].text;
        let list1 = [];
        for (let j in this.fruit.fruitlist.items) {
          let subitem2 = this.fruit.fruitlist.items[j];

          if (
            subitem2.MARKET == subitem1 &&
            subitem2.CROP_CODE == this.fruit.fruitlist.value.code
          ) {
            let obj1 = {
              date: subitem2.ANA_DATE,
              avgprice: subitem2.PRICE_AVG,
              volume: subitem2.VOLUME,
            };
            list1.push(obj1);
          }
        }
        
        let obj2 = { name: subitem1, data: list1 };
        mainlist.push(obj2);
        
      }

      for (let k in mainlist) {
        let element1 = mainlist[k];
        let avglist = [],
          volumelist = [];

        for (let t in datelist) {
          let subdate = datelist[t];
          let subindex = element1.data.findIndex((y) => y.date == subdate);
          if (subindex != -1) {
            let element2 = element1.data[subindex];
            avglist.push(element2.avgprice);
            volumelist.push(element2.volume);
          } else {
            avglist.push(0);
            volumelist.push(0);
          }
        }
        
        let volumeobj = {
          name: element1.name + "交易量",
          type: "column",
          data: volumelist,
        };

        serieslist.push(volumeobj);

        let avgobj = {
          name: element1.name + "拍賣均價",
          type: "line",
          data: avglist,
        };

        serieslist.push(avgobj);

        let volumeoption = {},
          avgoption = {};
        if (k == 0) {
          volumeoption = {
            seriesName: "交易量",
            title: {
              text: "交易量(公斤)",
            },
          };

          avgoption = {
            seriesName: "拍賣均價",
            opposite: true,
            title: {
              text: "價格 ( 元 / 公斤 )",
            },
          };
        } else {
          volumeoption = {
            seriesName: "交易量",
            show: false,
          };

          avgoption = {
            seriesName: "拍賣均價",
            show: false,
          };
        }

        this.fruit.obj.chart.options.yaxis.push(volumeoption);
        this.fruit.obj.chart.options.yaxis.push(avgoption);
      }

      if (this.fruit.averageprice || this.fruit.maintainprice) {
        let averagelist2 = [],
          mantainlist2 = [],
          datelist3 = [];
        for (let l in datelist) {
          let dateelement = datelist[l];
          for (let n in this.fruit.fruitlist.items) {
            let subitem5 = this.fruit.fruitlist.items[n];
            if (
              datelist3.indexOf(subitem5.ANA_DATE) == -1 &&
              subitem5.ANA_DATE == dateelement &&
              subitem5.CROP_CODE == this.fruit.fruitlist.value.code
            ) {
              if (this.fruit.averageprice) {
                let avgprice =
                  (subitem5.CM_PRICE_C +
                    subitem5.CM_PRICE_M +
                    subitem5.CM_PRICE_F) /
                  3;
                averagelist2.push(avgprice.toFixed(2));
              }

              if (this.fruit.maintainprice) {
                mantainlist2.push(subitem5.CM_PRICE_MON);
              }
              datelist3.push(subitem5.ANA_DATE);
            }
          }
        }

        if (averagelist2.length > 0) {
          let obj = {
            name: "嘉義縣產地均價",
            type: "line",
            data: averagelist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }

        if (mantainlist2.length > 0) {
          let obj = {
            name: "農糧署產地價格監控",
            type: "line",
            data: mantainlist2,
          };
          serieslist.push(obj);

          if (this.fruit.obj.chart.options.yaxis.length == 0) {
            let chartoption = {
              seriesName: "拍賣均價",
              opposite: true,
              title: {
                text: "價格 ( 元 / 公斤 )",
              },
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          } else {
            let chartoption = {
              seriesName: "拍賣均價",
              show: false,
            };
            this.fruit.obj.chart.options.yaxis.push(chartoption);
          }
        }
      }

      this.fruit.obj.chart.series = serieslist;
      let formatdate = [];
      for(var item in datelist){
        let formatitem = "";
        let mot = "";
        formatitem = datelist[item].split('T')[0];
        mot = (parseInt(formatitem.split('-')[0])-1911).toString();
        formatdate.push(mot+'/'+formatitem.split('-')[1]+'/'+formatitem.split('-')[2]);
      }
      // console.log("formatdate",formatdate);
      // console.log("this.fruit.obj.chart.options.labels",datelist)
      //this.fruit.obj.chart.options.labels = datelist;
      this.fruit.obj.chart.options.labels = formatdate;
      // this.fruit.obj.chart.series.forEach((x) => {
      //   x.data.unshift(null);
      //   x.data.push(null);
      // });

      // let labellist = [];

      // for (let l in datelist) {
      //   let subdate3 = datelist[l].split("T")[0].split("-");
      //   subdate3[0] = parseInt(subdate3[0]) - 1911;
      //   labellist.push(subdate3.join("/"));
      // }

      // this.fruit.obj.chart.options.labels = labellist;

      // //往前加一天
      // let date1 = this.getnewdate(labellist[0], 0);
      // this.fruit.obj.chart.options.labels.unshift(date1);

      // //往前減一天
      // let date2 = this.getnewdate(labellist[labellist.length - 1], 1);
      // this.fruit.obj.chart.options.labels.push(date2);
      if(this.dataLabels) this.fruit.obj.chart.options.dataLabels.enabled =true;
      else this.fruit.obj.chart.options.dataLabels.enabled =false;
      this.ifloading = false;
      if (this.$refs.chart1ref != undefined) {
        this.$refs.chart1ref.updateSeries(this.fruit.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.fruit.obj.chart.options);
        // this.fruit.ifchartshow = false
        this.$nextTick(() => {
          let markers = document.getElementsByClassName(
            "apexcharts-legend-marker"
          );
          console.log(markers);
        });
      }
    },
    getnewdate(date, index) {
      let firstdate = date.split("-");
      firstdate[0] = parseInt(firstdate[0]) + 1911;
      let subdate = new Date(firstdate.join("-"));
      if (index == 0) {
        subdate.setDate(subdate.getDate() - 1);
      } else {
        subdate.setDate(subdate.getDate() + 1);
      }
      let formatDate =
        parseInt(subdate.getFullYear()) -
        1911 +
        "-" +
        (subdate.getMonth() + 1) +
        "-" +
        subdate.getDate();
      return formatDate;
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
  },
};
</script>
